export const TRADE_SESSION_PAGE_UUID = '23862be5-e055-4f3f-aae7-3c2f9f65a029'
